import "./hotspots-plugin";
